var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-container",
    {
      staticClass: "agenda",
      attrs: {
        title: _vm.$t(_vm.lblSetting.agendaTitle),
        loading: false,
        "search-visible": false,
        "hide-add-button": true,
        "hide-edit-button": true
      }
    },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "align-center": "",
                "justify-start": "",
                row: "",
                "fill-height": ""
              }
            },
            [
              _c("v-toolbar-title", { staticClass: "title primary--text" }, [
                _vm._v(_vm._s(_vm.titleDateFormatted))
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return (function() {
                        return _vm.handleChangeDate("today")
                      })($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.btnToday)))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    fab: "",
                    small: "",
                    outline: "",
                    flat: "",
                    color: "primary"
                  },
                  nativeOn: {
                    click: function($event) {
                      return (function() {
                        return _vm.handleChangeDate("prev")
                      })($event)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [
                    _vm._v("chevron_left")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    fab: "",
                    small: "",
                    outline: "",
                    flat: "",
                    color: "primary"
                  },
                  nativeOn: {
                    click: function($event) {
                      return (function() {
                        return _vm.handleChangeDate("next")
                      })($event)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [
                    _vm._v("chevron_right")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "sub-nav" },
        [
          _c(
            "v-flex",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-btn-toggle",
                {
                  staticClass: "switch-mode",
                  on: { change: _vm.handleChangeView },
                  model: {
                    value: _vm.dtViewMode,
                    callback: function($$v) {
                      _vm.dtViewMode = $$v
                    },
                    expression: "dtViewMode"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "switch-mode",
                      class: _vm.getActivedClass("month"),
                      attrs: {
                        flat: "",
                        small: "",
                        outline: "",
                        value: "month"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(_vm.lblSetting.agendaMonth)) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "switch-mode",
                      class: _vm.getActivedClass("agendaWeek"),
                      attrs: {
                        flat: "",
                        small: "",
                        outline: "",
                        value: "agendaWeek"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(_vm.lblSetting.agendaWeek)) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("agenda-sidebar-datepicker", {
                attrs: { dots: _vm.eventDotsForDatepicker },
                on: { change: _vm.handleChangeDatePicker }
              }),
              _vm._v(" "),
              _vm.conditionVisible ? _c("agenda-sidebar-condition") : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("agenda-calendar", {
        attrs: {
          "current-date": _vm.coCurrentDate,
          "start-date": _vm.coStartDate
        },
        on: {
          "update:currentDate": function($event) {
            _vm.coCurrentDate = $event
          },
          "update:startDate": function($event) {
            _vm.coStartDate = $event
          },
          eventClick: _vm.handleCalendarEventClick,
          select: _vm.handleCalendarSelect
        },
        model: {
          value: _vm.dtAgendaElement,
          callback: function($$v) {
            _vm.dtAgendaElement = $$v
          },
          expression: "dtAgendaElement"
        }
      }),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          ref: "modal",
          attrs: {
            loading: _vm.dtValidateIsLoading,
            "submit-btn-title": _vm.$t(_vm.lblSetting.btnSaveWithInValidate),
            "max-width": _vm.coIsAppointment ? "90%" : "60%",
            icon: "book",
            title: _vm.$t(_vm.modalTitle)
          },
          on: { onRecord: _vm.handleSave },
          model: {
            value: _vm.dtAgendaDialogVisible,
            callback: function($$v) {
              _vm.dtAgendaDialogVisible = $$v
            },
            expression: "dtAgendaDialogVisible"
          }
        },
        [
          _c("agenda-modal-vertical"),
          _vm._v(" "),
          _vm.createWithoutValidateButtonVisible
            ? _c(
                "template",
                { slot: "action" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        flat: "",
                        color: "primary",
                        loading: _vm.dtWithoutValidateIsLoading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleSaveWithoutValidate($event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(_vm.lblSetting.btnSaveWithoutValidate)
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c5b296f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c5b296f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/agenda/template.html
// module id = null
// module chunks = 